import React, { memo, useContext } from "react";
import TrustedWorkersEmployeeTabs from "./truested-worker-employee-tabs";
import { JobDetailsContext } from "../job-detail1";
import { useSelector } from "react-redux";

const AddTrustedWorkerEmployeePopup = () => {
  const { userInfo, role_type } = useSelector((state) => state.menu);
  const { jobDetailsInfo } = useContext(JobDetailsContext);

  return (
    <div
      className="modal fade twm-saved-jobs-view"
      id="add_employee_trusted_worker_popup"
      aria-hidden="true"
      aria-labelledby="sign_up_popupLabel2"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex={-1}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "800px" }}
      >
        <div className="modal-content">
          <div className="modal-header" style={{ marginTop: "0px" }}>
            <h2 className="modal-title" id="sign_up_popupLabel2">
               {
                (role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
                role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN"))
                  ? "Add Worker"
                  : userInfo?.institutionId === jobDetailsInfo?.institutionEntityId
                  ? "Add Worker"
                  : "Apply for Job"
              }
            </h2>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div
            className="modal-body"
            style={{
              padding: "20px 20px",
              maxHeight: "600px",
              overflowY: "scroll",
            }}
          >
            <TrustedWorkersEmployeeTabs />
          </div>
          {/* <div className="modal-footer">
            <button
              type="button"
              className="site-button"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default memo(AddTrustedWorkerEmployeePopup);
